import { Cache } from "memory-cache";
import { CategoryEntity } from ".";
import { StaticStorageClient } from "../service/staticstorageclient";

const dataClient = new StaticStorageClient();
// Cache
const cache = new Cache();

export async function getCachedCategoryEntity(category_id: number): Promise<CategoryEntity | null> {
  let entity: any = await cache.get(category_id.toString());
  if (entity) {
    return entity;
  }
  try {
    const category = await dataClient.get_category_by_id(category_id);
    if (category !== null) {
      const groupsInCategory = await dataClient.get_groups_in_category(category_id);
      entity = new CategoryEntity(category_id, category, groupsInCategory);
      cache.put(category_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
      return entity;
    } else {
      return null;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
}
